export default __webpack_public_path__ + "static/SRC 4400 - Product Specifications & Technical Data-4851b093e2ef099eb8bbbd65c6eabf82.pdf";